/**
 * useAuthState hook
 * Manages authentication state and subscription access
 */

import { useState, useEffect } from 'react';
import { User } from 'firebase/auth';
import { onAuthStateChanged } from '@/services/auth.service';
import { hasActiveAccess } from '@/services/organization.service';

export function useAuthState() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(async (authUser) => {
      setUser(authUser);

      if (authUser) {
        // Check subscription status
        const access = await hasActiveAccess(authUser.uid);
        setHasAccess(access);
      } else {
        setHasAccess(false);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { user, loading, hasAccess };
}
